export default "__VITE_ASSET__75554da6__"